import React from 'react'
import { useTranslation } from 'react-i18next'
import { IconArrowUp } from '../../../../shared/components/icons/IconArrowUp'
import { IconArrowDown } from '../../../../shared/components/icons/IconArrowDown'

interface KeywordsCountCellProps {
  title: string
  keywords_count: number
  prev_keywords_count: number
  last_found: string
  expandedRowKeys?: string[]
  onToggleExpand?: (isShow: boolean, key: string) => void
}

export const KeywordsCountCell = ({
  title,
  keywords_count,
  prev_keywords_count,
  last_found,
  expandedRowKeys,
  onToggleExpand,
}: KeywordsCountCellProps) => {
  const { t } = useTranslation()
  const key = `${title}${last_found}`

  return (
    <div className='flex items-center'>
      <span className='w-8'>{keywords_count}</span>

      {keywords_count > prev_keywords_count ? (
        <span className='flex items-center pr-4 text-success-400'>
          <IconArrowUp className='w-4' color='#4DB11E' />
          {keywords_count - prev_keywords_count}
        </span>
      ) : keywords_count < prev_keywords_count ? (
        <span className='flex items-center pr-4 text-danger'>
          <IconArrowDown className='w-4' color='#DC2F02' />
          {prev_keywords_count - keywords_count}
        </span>
      ) : null}

      {expandedRowKeys?.includes(key) ? (
        <span
          className={
            'ml-auto cursor-pointer border-b border-dotted text-[13px] leading-[13px] text-focus'
          }
          onClick={() => {
            onToggleExpand && onToggleExpand(false, key)
          }}
        >
          {t('buttons.close')}
        </span>
      ) : (
        <span
          className={
            'ml-auto cursor-pointer border-b border-dotted text-[13px] leading-[13px] text-focus'
          }
          onClick={() => {
            onToggleExpand && onToggleExpand(true, key)
          }}
        >
          {t('buttons.show')}
        </span>
      )}
    </div>
  )
}
